export { default as AuthRoutes } from 'auth/routes/AuthRoutes';
export { default as QrRoutes } from 'auth/routes/QrRoutes';



// WEBPACK FOOTER //
// src/modules/auth/routes/index.js